/**
 * Les questions de la banque que la composition affiche : celles du niveau de
 * la classe, puis celles des attendus d'un autre niveau déjà ouverts
 * (2026-09-29), sans doublon. Une question écrite dans une 4e sur un attendu
 * de 6e est rangée en 4e ET revient avec l'attendu : elle ne doit compter
 * qu'une fois. Sans rien à ajouter, la liste de la classe est rendue telle
 * quelle (même objet : rien ne se recalcule en aval).
 */
export const fusionnerQuestions = (base, autres) => {
    const liste = Array.isArray(base) ? base : [];
    const vues = new Set(liste.map((q) => q.id));
    const enPlus = [];
    (autres || []).forEach((q) => {
        if (!q || vues.has(q.id)) return;
        vues.add(q.id);
        enPlus.push(q);
    });
    return enPlus.length ? [...liste, ...enPlus] : liste;
};
